import {useMemo} from 'react'

import {useClaimDocumentTypesQuery} from '@progyny/generated/graphql'

interface HookProps {
  documentTypes: DocumentTypes
  loading: boolean
}

type DocumentType = {
  value: string
  label: string
}

type DocumentTypes = DocumentType[]

export const useDocumentTypes = (): HookProps => {
  const {data, loading} = useClaimDocumentTypesQuery()

  const documentTypes = useMemo(() => {
    if (loading || !data?.claimDocumentTypes) return []

    return data.claimDocumentTypes
      .slice() // for sort, in-place sorting gives readonly error
      .sort((a, b) => (a?.dropdownOrder || 0) - (b?.dropdownOrder || 0))
      .map((item) => ({
        value: item?.typeName as string,
        label: item?.typeName as string,
      }))
  }, [data, loading])
  return {documentTypes, loading}
}
